import { TinyColor, mostReadable } from '@ctrl/tinycolor';
import { isReactNative } from './platform.js';
import { styles } from '../../constants/styles.js';

// TODO: TinyColor increases bundle size by ~14K (5K gzipped)

/**
 * Converts `px` values to `rem`, assuming a base font size of 16px.
 *
 * On React Native which lacks `rem` support, simply appends `px`.
 * If typeof string just return it as is. This allows theme configs to be numbers or already defined strings (rem,px,em...)
 */
var px2rem = function px2rem(px) {
  return isReactNative() ? "".concat(px, "px") : typeof px === 'number' ? "".concat(px / styles.fontSize.base, "rem") : px;
};

/**
 *  Render the number as px-postfixed string
 *  */
var inPixels = function inPixels(px) {
  return typeof px === 'number' ? "".concat(px, "px") : px;
};
var focusDarken = 15;
var focusLighten = 20;
var hoverDarken = 15;
var hoverLighten = 20;
var hoverMix = 25;
var visitedDarken = 15;
var visitedLighten = 20;
/**
 * Enables Elemental's transition timing function, and enables transitions on
 * given CSS properties with given duration values
 * @param cssTransitionProps - Properties to apply transition timing to
 */
var setTransitionProps = function setTransitionProps(cssTransitionProps) {
  return {
    transition: Object.keys(cssTransitionProps).map(function (cssProperty) {
      return "".concat(cssProperty, " ").concat(cssTransitionProps[cssProperty], "ms");
    }).join(', '),
    transitionTimingFunction: styles.transition["function"].base
  };
};
var getColorMixValues = function getColorMixValues(textColors, backgroundColor, mixColor) {
  var _mostReadable;
  var color = new TinyColor(mixColor);
  var background = new TinyColor(backgroundColor);
  var hoverBackground = background.mix(color, hoverMix);

  /* istanbul ignore next */
  var textColor = (_mostReadable = mostReadable(hoverBackground, textColors)) === null || _mostReadable === undefined ? undefined : _mostReadable.toHexString();
  return {
    fg: textColor,
    bg: hoverBackground.toHexString()
  };
};
function opacify(color, amount) {
  var tinyColor = new TinyColor(color);
  return tinyColor.setAlpha(amount).toRgbString();
}
function hex2rgba(color) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return opacify(color, amount);
}

export { focusDarken, focusLighten, getColorMixValues, hex2rgba, hoverDarken, hoverLighten, hoverMix, inPixels, opacify, px2rem, setTransitionProps, visitedDarken, visitedLighten };
